module.exports = __webpack_public_path__ + "static/Camping3-defee5cca643f984c34b0397fe381cc3.jpg";